/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Metapic Internal Payments API Documentation
 * <p>API documentation for Metapic internal APIs. This documentation covers payment-related endpoints including payment summaries, cost summaries, payout history, and general payment operations.</p>
      <h2>Authentication</h2>
      <p>This API uses <strong>Bearer Token</strong> authentication. You must include a valid token in the <strong>Authorization</strong> header with every request to access protected endpoints.</p>
      <h4>Example:</h4>
      <pre>Authorization: Bearer <i>your_token_here</i></pre>
      <p>*Replace <i>your_token_here</i> with your actual Bearer token. All API requests require this token for authentication.</p>
 * OpenAPI spec version: 1.0
 */
import * as axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'

import type {
  AffiliateLinkStatsControllerGetLinkStatsParams,
  LinkStats,
} from '../metapicInternalPaymentsAPIDocumentation.schemas'

export const getAffiliateLinkStats = (axiosInstance: AxiosInstance = axios.default) => {
  /**
   * Returns aggregated earnings, potential earnings, clicks, and order value for an affiliate link, broken down by source, plus estimated views, estimated unique views and estimated media value of the approved social media content using the link. If no date range is provided, all-time statistics are returned. Estimated views are filtered on the content publish date and the media value is in the advertiser currency. Only the link creator or an admin can access this endpoint.
   * @summary Get affiliate link source stats
   */
  const affiliateLinkStatsControllerGetLinkStats = (
    id: number,
    params?: AffiliateLinkStatsControllerGetLinkStatsParams,
    options?: AxiosRequestConfig,
  ): Promise<AxiosResponse<LinkStats>> => {
    return axiosInstance.get(`/affiliate-links/${id}/stats`, {
      ...options,
      params: { ...params, ...options?.params },
    })
  }
  return { affiliateLinkStatsControllerGetLinkStats }
}
export type AffiliateLinkStatsControllerGetLinkStatsResult = AxiosResponse<LinkStats>
